import React, { useMemo } from 'react'
import { Button, Menu } from '@CommonComponents/buttons'

// The caller supplies page coordinates; fixed registry menus take viewport coordinates.
// opened changes with each right-click, so a second one at the same spot opens the menu again.
// items: [{key, label, icon, disabled?, title?, onSelect}]
export const CoverpageContextMenu = ({
  x,
  y,
  opened,
  header,
  items,
  onClose,
}) => {
  const anchorPoint = useMemo(() => {
    const clientX = x - window.scrollX
    const clientY = y - window.scrollY
    return {
      x: clientX,
      y: clientY,
      returnFocus:
        document
          .elementFromPoint?.(clientX, clientY)
          ?.closest('[data-author-region]') || document.activeElement,
    }
  }, [x, y, opened])

  return (
    <Menu
      label={header || 'Author tools'}
      anchorPoint={anchorPoint}
      onAfterClose={onClose}
    >
      {header && (
        <div className="me-menu-heading" role="presentation">
          {header}
        </div>
      )}
      {items.map(item => (
        <Button
          key={item.key}
          aria-disabled={item.disabled || undefined}
          title={item.title}
          icon={item.icon}
          onClick={() => item.onSelect()}
        >
          {item.label}
        </Button>
      ))}
    </Menu>
  )
}
